

/**
 * Gets the token from /.auth/me endpoint - for this the EasyAuth (App service built in authentication)
 * must be set up. It automatically authenticates the user when he opens the app and the access-token, id_token and so on
 * is accessible at this endpoint (token_store must be ON) - https://learn.microsoft.com/en-us/azure/app-service/configure-authentication-user-identities#access-user-claims-using-the-api
 * @returns Access Bearer token from EasyAuth
 */
export const getTokenFromTokenStore = async (): Promise<string | undefined> => {
    const headers = {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'credentials': 'include'
    };
    const requestOptions = {
        method: 'GET',
        headers: headers,
    };

    const resp = await fetch("/.auth/me", requestOptions);//fetch(tokenStoreUrl);
    if (resp.status === 401) throw new Error("Unauthorized");
    if (!resp.ok) return undefined;
    const respJson: any = await resp.json();
    return respJson[0].access_token;
}
